import React from 'react'
import Note from './PracticeGuidelines/Note'

/**
 * Renders a category component with its items.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.categoryComponent
 * @param {Object} props.items
 * @param {string} [props.note]
 * @param {Object} [props.categoryComponentProps] - Extra props spread into `categoryComponent`.
 *   Used by the owning surface to opt specific categories into actions (e.g. an
 *   `onOpenSetup` callback for the Copilot's elastics eye-icon). Default `{}` keeps every
 *   other consumer presentation-only.
 */
const CategoryItems = ({ categoryComponent, items, note, categoryComponentProps = {} }) => {
  return (
    <div>
      {React.createElement(categoryComponent, {
        items,
        ...categoryComponentProps
      })}
      {note && (
        <div style={{ width: '100%' }}>
          <Note note={note} />
        </div>
      )}
    </div>
  )
}

export default CategoryItems
